import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const historySvgIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 12.0673C4 16.5228 7.3674 20.1347 11.9059 20.1347C16.4444 20.1347 20.1236 16.5228 20.1236 12.0673C20.1236 7.61191 16.4444 4 11.9059 4C9.70866 4 7.83552 4.92754 6.36106 6.30657"
            stroke="currentColor"
            strokeWidth="1.0"
        />
        <path d="M6.22052 4.08012L6.45669 6.35127H8.72449" stroke="currentColor" strokeWidth="1" />
        <path d="M11.6537 6.91904V12.1712L15.1025 16.3349" stroke="currentColor" strokeWidth="1" />
    </svg>
)
const HistoryIcon: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{historySvgIcon}</SvgIcon>

export default HistoryIcon
